import { JSXElement, mergeProps, Show } from 'solid-js';
import { Tag } from '~/components/ui/Tag';
import { Localized } from '~/i18n';
import { getTranslationKey } from '~/pages/ScalekitConnect/Integrations/utils.tsx';
import {
  ConnectedAccountData,
  ConnectedAccountStatus
} from '~/api/types/connectedAccounts.ts';
import { getTranslationKeyFunction } from '~/utils/commonUtils.ts';

type ConnectionStatusTagProps = {
  account: ConnectedAccountData | null;
};

const CONNECTED_ACCOUNT_STATUS_TRANSLATION_KEYS: Record<
  ConnectedAccountStatus,
  string
> = {
  [ConnectedAccountStatus.ACTIVE]: 'active',
  [ConnectedAccountStatus.PENDING_AUTH]: 'pending_auth',
  [ConnectedAccountStatus.EXPIRED]: 'expired',
  [ConnectedAccountStatus.DISCONNECTED]: 'pending_auth'
};

export default function ConnectedAccountStatusTag(
  props: ConnectionStatusTagProps
): JSXElement {
  const merged = mergeProps({}, props);

  const getConnectedAccountStatusTranslationKey = getTranslationKeyFunction(
    getTranslationKey('connected_account_statuses')
  );

  return (
    <Show
      when={
        merged.account &&
        merged.account?.status === ConnectedAccountStatus.ACTIVE
      }
      fallback={
        <Tag
          variant={`secondary`}
          class={`inline-flex mx-0`}
        >
          <Localized
            translationKey={getConnectedAccountStatusTranslationKey(
              CONNECTED_ACCOUNT_STATUS_TRANSLATION_KEYS[
                merged.account?.status ?? ConnectedAccountStatus.PENDING_AUTH
              ]
            )}
          />
        </Tag>
      }
    >
      <Tag
        variant={`success`}
        class={`inline-flex mx-0`}
      >
        <Localized
          translationKey={getConnectedAccountStatusTranslationKey(
            CONNECTED_ACCOUNT_STATUS_TRANSLATION_KEYS[
              ConnectedAccountStatus.ACTIVE
            ]
          )}
        />
      </Tag>
    </Show>
  );
}
